export const themeCssVariables = [
  ['--color-alertError', '#e06050'],
  ['--color-alertInformational', '#5b9be0'],
  ['--color-alertSuccess', '#66ad5a'],
  ['--color-alertWarning', '#e5973c'],
  ['--color-brandBlack', '#131313'],
  ['--color-brandBlue', '#6ca3e0'],
  ['--color-brandGreen', '#d2d943'],
  ['--color-brandLightGray', '#f6f6f6'],
  ['--color-brandOrange', '#ff9e31'],
  ['--color-brandPurple', '#8f6fdb'],
  ['--color-brandSalmon', '#f2a28a'],
  ['--color-brandWatermelon', '#ff5a5e'],
  ['--color-brandWhite', '#ffffff'],
  ['--color-brandYellow', '#f2c94c'],
  ['--color-gray10', '#f6f6f6'],
  ['--color-gray20', '#eeeeee'],
  ['--color-gray30', '#e3e3e3'],
  ['--color-gray40', '#d1d1d1'],
  ['--color-gray50', '#acacac'],
  ['--color-gray60', '#8b8b8b'],
  ['--color-gray70', '#646464'],
  ['--color-gray80', '#515151'],
  ['--color-gray90', '#333333'],
  ['--color-green10', '#f0f7ee'],
  ['--color-green20', '#e0efde'],
  ['--color-green30', '#d1e6ce'],
  ['--color-green40', '#c2debd'],
  ['--color-green50', '#b3d6ad'],
  ['--color-green60', '#a3ce9c'],
  ['--color-green70', '#94c68c'],
  ['--color-overlay10', 'rgba(19,19,19,0.5)'],
  ['--color-overlay20', 'rgba(0,0,0,0.77)'],
  ['--color-red10', '#fcefed'],
  ['--color-red20', '#f9dfdc'],
  ['--color-red30', '#f6cfcb'],
  ['--color-red40', '#f3bfb9'],
  ['--color-red50', '#f0b0a7'],
  ['--color-red60', '#eca096'],
  ['--color-red70', '#e99084'],
  ['--color-socialInvision', '#dc395f'],
  ['--color-socialReact', '#53c1de'],
  ['--color-socialTwitter', '#4aa1eb'],
  ['--color-uiBlackDisabled', 'rgba(19,19,19,0.4)'],
  ['--color-uiBlackHighEmphasis', '#131313'],
  ['--color-uiBlackMediumEmphasis', 'rgba(19,19,19,0.67)'],
  ['--color-uiErrorFocus', '#ce0e19'],
  ['--color-uiErrorRegular', '#e90f1c'],
  ['--color-uiFilterGreen', '#cdedc7'],
  ['--color-uiInputBackground', 'rgba(242,242,242,0.4)'],
  ['--color-uiSelected', '#dfeaf9'],
  ['--color-white10', 'rgba(255,255,255,0.36)'],
  ['--color-white20', 'rgba(255,255,255,0.43)'],
  ['--color-white30', 'rgba(255,255,255,0.63)'],
  ['--color-white40', 'rgba(255,255,255,0.86)'],
  ['--color-yellow10', '#fdf6e0'],
  ['--color-yellow20', '#fae7b1'],
  ['--color-yellow30', '#f6d77f'],
  ['--color-yellow40', '#f2c94c'],
  ['--color-yellow50', '#f0bc27'],
  ['--color-yellow60', '#edb104'],
  ['--color-yellow70', '#eda400'],
  [
    '--font-body',
    'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  ],
  [
    '--font-headline',
    'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
  ],
  [
    '--font-mono',
    '"IBM Plex Mono", SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace',
  ],
  ['--font-signature', 'Handlee, cursive'],
] as const;
